import React from "react";
import "./Landing.css";

function Landing() {
  return (
    <div className="landing-section text-center py-5 bg-light" style={{ marginTop: '50px' }}>
      <img src="/assets/images/logo_upself.svg" alt="UPSelf logo" width={220} />
      <h1 className="mt-4 display-4 font-weight-bold">Understand Yourself. Empower Your Future.</h1>
      <p className="text-muted mb-4">
        AI-driven psychological insights using advanced Graph Theory for individuals and professionals.
      </p>
      {/* <div className="buttons">
        <a href="mailto:contact@upself.io" className="btn btn-primary mx-2">Try the API</a>
        <a href="#rodrigo-profile" className="btn btn-outline-secondary mx-2">Meet Rodrigo</a>
      </div> */}

      <div className="stage mt-5">
        <div className="box bounce-7">
          <img src="/assets/images/upsy_emo/upsy1_emo3.svg" width="200" alt="Upsy Mascot" />
        </div>
      </div>
    </div>
  );
}

export default Landing;
